module.exports = __webpack_public_path__ + "img/calendars.505ad599.svg";